import React, { createContext, useContext, useMemo } from 'react'

import { ControllersMiddlewareContext } from '@common/contexts/controllersMiddlewareContext'
import {
  backgroundServiceContextDefaults,
  BackgroundServiceContextReturnType
} from '@web/contexts/backgroundServiceContext/types'

// Native: BackgroundService is web-extension-only (MV3 service worker).
// On RN we forward dispatches to the WebViewWorker via ControllersMiddleware
// so callers that still use useBackgroundService() keep working.
const BackgroundServiceContext = createContext<BackgroundServiceContextReturnType>(
  backgroundServiceContextDefaults
)

const BackgroundServiceProvider: React.FC<any> = ({ children }) => {
  const { dispatch } = useContext(ControllersMiddlewareContext)

  const value = useMemo(
    () => ({ dispatch: dispatch as any, windowId: undefined }),
    [dispatch]
  )

  return (
    <BackgroundServiceContext.Provider value={value}>{children}</BackgroundServiceContext.Provider>
  )
}

export { BackgroundServiceProvider, BackgroundServiceContext }
